import {AppSettingsRepo, SettingsKeys} from "../settings/IAppSettingsRepo";
import {SyncDevice} from "./SyncDevice";

const getCurrentSyncDeviceUUID = async () => {
    return await AppSettingsRepo.get<SyncDevice['uuid']>(SettingsKeys.syncUUID);
}

export default getCurrentSyncDeviceUUID;